import { faker } from "@faker-js/faker/locale/fr"
import { type IsoDate, type KeyFigure, SourceName } from "../../../types"
import type { ApiLabSales } from "../../laboratorySales"

const mockKeyFigure = (range: {
  min: number
  max: number
}): KeyFigure | undefined =>
  faker.helpers.maybe(() => ({
    mainStat: faker.number.int(range),
    evolution: faker.number.float({ min: -100, max: 100, fractionDigits: 1 }),
  }))

const mockIsoDate = (): IsoDate | undefined =>
  faker.helpers.maybe(() =>
    faker.date.recent({ days: 90 }).toISOString().slice(0, 10),
  )

export const labPerfSalesMock = (): ApiLabSales => ({
  salesValue: mockKeyFigure({ min: 0, max: 10_000_000 }),
  ultraSalesValue: mockKeyFigure({ min: 0, max: 5_000_000 }),
  ultraSalesShare: faker.helpers.maybe(() =>
    faker.number.float({ min: 0, max: 100, fractionDigits: 1 }),
  ),
  pharmacyCount: mockKeyFigure({ min: 0, max: 5_000 }),
  units: mockKeyFigure({ min: 0, max: 1_000_000 }),
  numReferences: faker.helpers.maybe(() => faker.number.int({ min: 0, max: 500 })),
  periodStartDate: mockIsoDate(),
  periodEndDate: mockIsoDate(),
  sources: [SourceName.SANTESTAT, SourceName.GERS],
})
